import React from 'react';

export default function BaseStationHandling() {
  return <div>BaseStationHandling</div>;
}
